// client/src/lib/walletDatabase.js
import { create } from 'zustand';
import { makeRequest } from "../utils/axios.js"; 

export const useWalletDatabase = create((set, get) => ({
    walletAddress: null,
    isConnecting: false,

    checkConnection: async () => {
        try {
            if (window.ethereum) {
                const accounts = await window.ethereum.request({ method: 'eth_accounts' });
                if (accounts.length > 0) {
                    set({ walletAddress: accounts[0] });
                }
            }
        } catch (error) {
            console.error("Lỗi kiểm tra ví:", error);
        }
    },

    connectWallet: async () => {
        if (!window.ethereum) {
            alert("Vui lòng cài đặt ví MetaMask (extension) để tiếp tục!");
            return null;
        }

        set({ isConnecting: true });

        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const account = accounts[0];
            set({ walletAddress: account, isConnecting: false });
            
            return account;
        } catch (error) {
            console.error("Lỗi kết nối ví:", error);
            set({ isConnecting: false });
            return null;
        }
    },

    updateWalletToBackend: async (address) => {
        try {
            await makeRequest.put("/users/update-wallet", { walletAddress: address });
            console.log("Đã cập nhật ví lên server thành công");
        } catch (error) {
            console.error("Lỗi lưu ví lên server:", error);
        }
    },

    disconnectWallet: () => {
        set({ walletAddress: null });
    }
}));